import styled from 'styled-components';

export const Container = styled.div`
  border: 2px solid ${(props) => props.theme.colors.red};
  background-color: ${(props) => props.theme.colors.red30};
  color: ${(props) => props.theme.colors.red};
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 2px;
  margin: 12px 0;

  p {
    font-size: 0.9rem;
    margin-left: 15px;
  }
`;
